import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiHelper, AuthGuardService, AuthService, HomeUrlHelper, SecurityHelper } from '@sc/pas-common';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(route, authService, api, urlHelper, securityService, authGuardService) {
        var _this = this;
        this.route = route;
        this.authService = authService;
        this.api = api;
        this.urlHelper = urlHelper;
        this.securityService = securityService;
        this.authGuardService = authGuardService;
        this.model = {};
        this.loading = false;
        this.urls = [{
                text: 'Contraseña Olvidada',
                link: '/Login/Loguin.aspx?Opcion=2&NuevoPortalToken=',
                origin: 'LEGACY_PORTAL',
                mode: 'TAB',
                route: 'legado'
            }, {
                text: 'Alta Usuario',
                link: '/Login/Loguin.aspx?Opcion=3&NuevoPortalToken=',
                origin: 'LEGACY_PORTAL',
                mode: 'TAB',
                route: 'legado'
            }];
        // Login funcion is declared as an arrow function in order
        // to be able to use it on onEnterDirective
        this.login = function (e) {
            if (!_this.loginFormGroup.valid) {
                localStorage.removeItem('hash');
                _this.validateAllFormFields(_this.loginFormGroup);
            }
            else {
                _this.loading = true;
                var password = _this.loginFormGroup.get('passwordHash').value;
                var passwordHashed_1 = _this.securityService.sha1().sha1(password.toLowerCase());
                if (passwordHashed_1) {
                    localStorage.setItem('hash', passwordHashed_1);
                }
                _this.api.login(_this.loginFormGroup.get('username').value, passwordHashed_1, _this.ignoreMaintenance).subscribe(function (response) {
                    _this.loading = false;
                    _this.loginFormError = null;
                    _this.evaluateRedirection(response.data, passwordHashed_1);
                }, function (err) {
                    _this.loading = false;
                    _this.loginFormError = 'Usuario o contraseña incorrecta.';
                });
            }
        };
        this.authGuardService.clearUserStoredData();
        this.authService.deletePersistedData();
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.loginFormGroup = new FormGroup({
            'username': new FormControl('', [
                Validators.required
            ]),
            'passwordHash': new FormControl('', [
                Validators.required
            ])
        });
        var strIgnoreMaintenance = this.route.snapshot.queryParams['ignoremaintenance'];
        this.ignoreMaintenance = strIgnoreMaintenance && strIgnoreMaintenance.toLowerCase() === 'true';
        // get return url from route parameters
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
        this.checkAppInMaintenance();
    };
    LoginComponent.prototype.evaluateRedirection = function (response, passwordHashed) {
        var options = (response.loginRedirect === 'PORTAL_TD') ? passwordHashed : this.generateUrl();
        this.api.redirectLogin(response, options, this.returnUrl);
    };
    LoginComponent.prototype.generateUrl = function () {
        var url = this.urlHelper.urlByOrigin('/Login/Loguin.aspx', 'LEGACY_PORTAL');
        return this.urlHelper.addTokenUrlItem(url, 'LEGACY_PORTAL', { showHeader: true });
    };
    LoginComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsDirty({ onlySelf: true });
                control.markAsPristine({ onlySelf: true });
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFormFields(control);
            }
        });
    };
    LoginComponent.prototype.goForgottenPassword = function () {
        // this.router.navigate(['/forgot-password'])
        var urlItem = this.urls[0];
        var urlParsed = this.urlHelper.urlByOrigin(urlItem.link, urlItem.origin);
        this.urlHelper.urlItemMode(this.urls[0].mode, urlParsed);
    };
    LoginComponent.prototype.goSignUp = function () {
        var urlItem = this.urls[1];
        var urlParsed = this.urlHelper.urlByOrigin(urlItem.link, urlItem.origin);
        this.urlHelper.urlItemMode(this.urls[0].mode, urlParsed);
    };
    LoginComponent.prototype.checkAppInMaintenance = function () {
        if (this.ignoreMaintenance) {
            console.log('Ignorando llamada de mantenimiento');
        }
        else {
            this.api.isAppMaintenance();
        }
    };
    return LoginComponent;
}());
export { LoginComponent };
